/* global window */
'use strict';

var hubRebalancer = require('./hubRebalancer');
var util = require('../lib/util');
const performanceMeasure = require('../lib/performanceMeasure.js');
let measure = performanceMeasure('bootscripts:hubRebalancer');

window.addEventListener('DOMContentLoaded', hubRebalancer);
window.addEventListener('contentAdded', hubRebalancer);

window.phxConfigQueue.push(function rebalanceOnBreakpointChange() {
    var getCurrentBreakpoint = this.breakpoint.get;
    var previousBreakpoint = getCurrentBreakpoint();

    window.addEventListener(
        'resize',
        util.throttle(function () {
            if (breakpointChanged()) {
                hubRebalancer();
            }
        }, 200)
    );

    function breakpointChanged() {
        var currentBreakpoint = getCurrentBreakpoint();

        if (currentBreakpoint !== previousBreakpoint) {
            previousBreakpoint = currentBreakpoint;
            return true;
        }

        return false;
    }
});

measure.end();
